// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
	max-width: 15rem;
	width: 15rem;
	max-height: 20rem;
	cursor: pointer;
}

.card:hover,
.card.selected {
	padding: 7px !important;
	border-width: 2px !important;
	--bs-border-opacity: 1;
	border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
	box-shadow: var(--bs-box-shadow) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/gallerytile.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,YAAY;CACZ,iBAAiB;CACjB,eAAe;AAChB;;AAEA;;CAEC,uBAAuB;CACvB,4BAA4B;CAC5B,sBAAsB;CACtB,2EAA2E;CAC3E,2CAA2C;AAC5C","sourcesContent":[".card {\n\tmax-width: 15rem;\n\twidth: 15rem;\n\tmax-height: 20rem;\n\tcursor: pointer;\n}\n\n.card:hover,\n.card.selected {\n\tpadding: 7px !important;\n\tborder-width: 2px !important;\n\t--bs-border-opacity: 1;\n\tborder-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n\tbox-shadow: var(--bs-box-shadow) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
